import NotesEditorStore from './schema/NotesEditorStore';
import { ObservableMap } from 'mobx';
import { NotesEditorViewState } from 'owa-calendar-notes-editor';
import { createStore } from 'satcheljs';

const store = createStore<NotesEditorStore>('calendarNotesEditorStore', {
    meetingIdToNotesViewStateMap: new ObservableMap<string, NotesEditorViewState>(),
});

export default store;
